// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function planFeature_decode($$enum) {
  if ($$enum === "CLIENT_ACCESS" || $$enum === "VIEWING_AGENT" || $$enum === "FORWARD_PROPERTY_EMAIL" || $$enum === "SHARE_WITH_CLIENT" || $$enum === "FULL_AGENT_PAGE" || $$enum === "PROPERTY_DETAILS" || $$enum === "GNS" || $$enum === "INITIATE_PROPERTY_CONVERSATION" || $$enum === "HIDE_PROPERTY") {
    return $$enum;
  }
}

let planFeature_fromString = planFeature_decode;

function planHandleV5_decode($$enum) {
  if ($$enum === "COMPLIMENTARY" || $$enum === "PRO_YEARLY" || $$enum === "FREE" || $$enum === "PRO_TRIAL" || $$enum === "PRO_FREE" || $$enum === "PRO_QUARTERLY" || $$enum === "PRO_MONTHLY") {
    return $$enum;
  }
}

let planHandleV5_fromString = planHandleV5_decode;

function planType_decode($$enum) {
  if ($$enum === "COMPLIMENTARY" || $$enum === "PRO_ONLY" || $$enum === "FREE" || $$enum === "PRO") {
    return $$enum;
  }
}

let planType_fromString = planType_decode;

let Utils = {
  planFeature_decode: planFeature_decode,
  planFeature_fromString: planFeature_fromString,
  planHandleV5_decode: planHandleV5_decode,
  planHandleV5_fromString: planHandleV5_fromString,
  planType_decode: planType_decode,
  planType_fromString: planType_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true,
    "catchTo": "RESULT"
  },
  "name": "UserSessionPlansFeatures_plan",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "features",
      "storageKey": null
    },
    {
      "alias": "type_",
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "handle",
      "storageKey": null
    }
  ],
  "type": "SubscriptionPlanV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
